export default "__VITE_ASSET__cdafce25__"